export default __webpack_public_path__ + "static/media/upload.24004196.svg";